<template>
  <div class="order_manage order-wait">
    <div class="top-box" v-if="config.id">
      <div class="text-box" v-if="config.noFinishedOrderAuthorized">
        <span class="text1">已授权凤栖云服跟进</span>
        <span class="text2">凤栖云服将以您的名义对未完成的订单及时跟进。</span>
        <span class="btn" @click="ruleVisible=true">查看规则</span>
      </div>
      <div class="text-box" v-else>
        <span class="text1">未授权凤栖云服跟进</span>
        <span class="text2">凤栖云服顾问将不再直接联系客户，请及时自行跟进，避免影响客户保障。</span>
      </div>
      <span class="btn" style="margin-left:30px;" @click="goAuth" v-if="checkAuth('authConfig')">去设置 ></span>
    </div>
    <div class="headerk" style="padding-bottom:10px;">
      <topSearchForm @search="allquery" :hiddenExport="!checkAuth('orderExport')" @export="daochu" :showSwtich="true">
        <el-form :inline="true" class="rform" :model="search" ref="loginform" label-position='right'>
          <el-form-item label="投保时间" prop="createTime" class="small">
            <a-range-picker class="date-picker" v-model="search.createTime" format="yyyy-MM-DD" valueFormat="yyyy-MM-DD  HH:mm:ss" separator="至">
              <i class="icon-riqixuanze" slot="suffixIcon"></i>
            </a-range-picker>
          </el-form-item>
          <el-form-item label="订单号" prop="orderId" class="small1">
            <el-input type="text" v-model="search.orderId" class="code" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="投保人姓名" prop="policyerName" class="small1">
            <el-input type="text" v-model="search.policyerName" class="code" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="productName">
            <el-input type="text" v-model="search.productName" class="code" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="订单状态" prop="orderStatus">
            <el-select v-model="search.orderStatus" placeholder="请选择" clearable>
              <el-option label="待支付" value="1"></el-option>
              <el-option label="人工审核" value="7"></el-option>
              <el-option label="核保失败" value="4"></el-option>
              <el-option label="生效" value="2"></el-option>
              <el-option label="已过期" value="5"></el-option>
              <el-option label="已退款" value="3"></el-option>
              <el-option label="已失效" value="6"></el-option>
              <!-- <el-option label="已撤单" value="8"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="跟进状态" prop="followStatus">
            <el-select v-model="search.followStatus" placeholder="请选择" clearable>
              <el-option label="待跟进" value="1"></el-option>
              <el-option label="跟进中" value="2"></el-option>
              <el-option label="跟进完成" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="授权状态" prop="unFinishedOrderAuthorized">
            <el-select v-model="search.unFinishedOrderAuthorized" placeholder="请选择" clearable>
              <el-option label="已授权" value="1"></el-option>
              <el-option label="未授权" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </topSearchForm>
    </div>
    <el-tabs v-model="search.orderType" @tab-click="allquery">
      <el-tab-pane :label="'全部订单（'+(countData.allOrderCount||0)+'）'" name="1"></el-tab-pane>
      <el-tab-pane :label="'我的订单（'+(countData.myOrderCount||0)+'）'" name="2"></el-tab-pane>
      <el-tab-pane :label="'下级机构订单（'+(countData.childOrderCound||0)+'）'" name="3" v-if="userinfo.isOpenMechanism==1"></el-tab-pane>
      <el-tab-pane :label="'员工订单（'+(countData.memberOrderCount||0)+'）'" name="4"></el-tab-pane>
    </el-tabs>
    <div class="list-tab">
      <el-tabs v-model="search.ensureType" @tab-click="allquery" type="card">
        <el-tab-pane :label="'全部（'+(countData.secondAllOrderCount||0)+'）'" name=""></el-tab-pane>
        <el-tab-pane :label="'长期险（'+(countData.secondLongOrderCount||0)+'）'" name="1"></el-tab-pane>
        <el-tab-pane :label="'短期险（'+(countData.secondShortOrderCount||0)+'）'" name="2"></el-tab-pane>
      </el-tabs>
      <div class="info-box">
        <div>共<span>{{countData.statisticOrderCount||0}}</span>笔订单</div>
        <div>未支付单保费：<span>{{countData.statisticUnPayFee||0}}元</span></div>
        <div>已支付单保费：<span>{{countData.statisticPayFee||0}}元</span></div>
      </div>
    </div>

    <div class="omcontent" v-loading="loading">
      <el-table class="omtable" ref="singleTable" border :stripe='true' tooltip-effect="dark" :data="tableData" style="width: 100%">
        <el-table-column type="index"></el-table-column>
        <el-table-column property="orderTime" min-width="150" label="投保时间">
          <template slot-scope="scope">{{scope.row.orderTime|timeSubstr(0,16)}}</template>
        </el-table-column>
        <el-table-column property="orderId" min-width="220" label="订单号" show-overflow-tooltip></el-table-column>
        <el-table-column property="productName" min-width="260" label="产品名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="holderName" min-width="120" label="投保人姓名" show-overflow-tooltip></el-table-column>
        <el-table-column property="fee" min-width="140" label="保费" show-overflow-tooltip></el-table-column>
        <el-table-column property="address" label="订单状态" min-width="100">
          <template slot-scope="scope">
            <span>{{all.ORDER_STATUS[scope.row.orderStatus]}}</span>
          </template>
        </el-table-column>
        <el-table-column property="address" label="授权状态" min-width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.unFinishedOrderAuthorized?'已授权':'未授权'}}</span>
          </template>
        </el-table-column>
        <el-table-column property="followStatusDesc" label="跟进状态" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" fixed='right' min-width='220'>
          <template slot-scope="scope">
            <el-button-group>
              <el-button type="primary" size='small' @click="openDetail(scope.row)">订单详情</el-button>
              <el-button type="danger" size='small' @click="openServiceDetail(scope.row)" :disabled="scope.row.unFinishedOrderAuthorized=='false'">服务日志</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="page" :current-page.sync='pageNum' background layout="total,prev, pager, next" :page-size='10' @current-change="handleCurrentChange"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="ruleVisible" width="800px" title="凤栖云服未完成订单跟进服务规则" class="rule-box">
      <div class="content">
        <div class="info-txt">为保证客户服务质量，提高客户转化率，凤栖客服将在渠道授权后跟进未完成订单，跟进规则如下：</div>
        <div class="bold">一、未完成订单分配规则：</div>
        <div>1.分配时效</div>
        <div>一小时内未完成的订单，将会进入未完成列表，分配客服跟进。</div>
        <div>2.分配范围</div>
        <div>未支付、核保中、核保失败的订单将进入未完成列表，分配客服跟进促进成交。</div>
        <div class="margin-top-10 bold">二、未完成订单跟进规则：</div>
        <div>1.跟进时效</div>
        <div>订单进入列表后，客服将会在一小时内跟进，当天20:00后产生的订单会在第二天跟进。</div>
        <div>2.跟进规则</div>
        <div>A.无人接听：每天三次呼出，发送短信，连续三天跟进，若三天内无人接听，客服不再跟进此单；</div>
        <div>B.支付异常：当天解决异常问题并引导成交。</div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="detailVisible" width="900px" title="服务日志">
      <div class="content">
        <el-table class="omtable" ref="singleTable" border :stripe='true' :data="serviceList" style="width: 100%">
          <el-table-column property="updateTime" min-width="250px;" label="服务时间"></el-table-column>
          <el-table-column property="chatTypeDesc" label="沟通方式" min-width="100px;"></el-table-column>
          <el-table-column property="content" label="服务内容" min-width="380px;"></el-table-column>
        </el-table>
        <el-pagination class="page" :current-page.sync='serviceCurrent' background layout="total,prev, pager, next" :page-size='10' @current-change="serviceCurrentChange"
          :total="serviceTotal">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import topSearchForm from '@/components/topSearchForm.vue'
import {common} from "@/api/mixins";
//当前实例组件
export default {
  mixins: [common],
  data: () => ({
    config: {},
    ruleVisible: false, //规则弹窗
    detailVisible: false, //服务日志弹窗
    serviceCurrent: 1, //服务日志当前页数
    serviceTotal: 0, //服务日志记录数
    serviceList: [],
    serviceParams: {},
    pageNum: 1,
    tableData: [],
    total: 0,
    countData: {},
    search: {
      orderType: '1',
      ensureType: '',
    },
  }),
  components: { topSearchForm },
  created() {
    this.getState()
    this.getConfig()
  },
  methods: {
    // 服务日志翻页
    serviceCurrentChange(page) {
      this.serviceCurrent = page
      this.getServiceList()
    },
    // 获取服务日志列表
    getServiceList() {
      const params = {
        orderId: this.serviceParams.orderId,
        pageNum: this.serviceCurrent,
        pageSize: 10,
      }
      this.$http({
        url: '/master/order/unfinishedOrderRecord',
        type: 'put',
        params: params,
      }).then((res) => {
        this.serviceList = res.data
        this.serviceTotal = res.total
        this.detailVisible = true
      })
    },
    // 打开服务日志详情
    openServiceDetail(item) {
      this.serviceCurrent = 1
      this.serviceList = []
      this.serviceParams = item
      this.getServiceList()
    },
    //获取all数据
    getState: function() {
      this.$tools.getall(this.setAll)
      this.userinfo = this.$tools.getLocal('userinfo')
    },
    setAll: function(data) {
      this.all = data
      this.gettableData(1)
    },

    openDetail: function(item) {
      this.$router.push('/order_detail?orderId=' + item.orderId)
    },
    goAuth() {
      this.$router.push({ path: '/setting/auth', query: { source: '1' } })
    },
    // 获取授权状态
    getConfig() {
      this.$http({
        url: '/master/mechan/queryMechanConfig',
        type: 'put',
        params: {},
      }).then((res) => {
        this.config = res.data
      })
    },
    daochu() {
      const params = this.getParams()
      delete params.pageNum
      delete params.pageSize
      let url =
        this.$config.api_root +
        '/master/order/exportUnfinishedOrder?' +
        this.$tools.urlEncode(params)
      console.log(url)
      window.open(url)
    },
    getParams() {
      const params = {
        pageNum: this.pageNum,
        pageSize: 10,
      }
      Object.assign(params, this.search) //写入查询参数
      if (params.createTime && params.createTime.length == 2) {
        params.startTime = params.createTime[0]
        params.endTime = params.createTime[1]
        delete params.createTime
      }
      return params
    },
    gettableData: function() {
      this.loading = true
      const params = this.getParams()
      console.log(params)
      this.$http({
        url: '/master/order/unfinishedOrderList',
        type: 'put',
        params: params,
      })
        .then((res) => {
          this.loading = false
          this.tableData = res.data
          this.total = res.total
          this.countData = res.extData
        })
        .catch((e) => {
          this.loading = false
        })
    },
    handleCurrentChange: function(val) {
      this.pageNum = val
      this.gettableData() //列表
    },
    allquery: function() {
      //查询
      this.pageNum = 1
      this.gettableData() //列表
    },
  },
  mounted() {
    var that = this
  },
}
</script>
<style lang="scss">
@import '~@/sass/pages/order_manage';
.daochu {
  margin-left: 10px !important;
}
</style>
<style lang="scss" scoped>
.headerk {
  .rform {
    .small {
      @media screen and (min-width: 1681px) {
        width: 33.333333%;
      }
      @media screen and (max-width: 1680px) {
        width: 42%;
      }
    }
    .small1 {
      @media screen and (min-width: 1681px) {
        width: 33.333333%;
      }
      @media screen and (max-width: 1680px) {
        width: 29%;
      }
    }
  }
}
</style>